import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { loadAnalyticsIfAllowed } from '../lib/analytics';
import { CONSENT_EVENT, readConsent, writeConsent } from '../lib/consent';

export default function CookieConsent() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [manage, setManage] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    const existing = readConsent();
    if (!existing) {
      setOpen(true);
      return;
    }
    loadAnalyticsIfAllowed();
  }, []);

  useEffect(() => {
    const onConsent = () => loadAnalyticsIfAllowed();
    window.addEventListener(CONSENT_EVENT, onConsent);
    return () => window.removeEventListener(CONSENT_EVENT, onConsent);
  }, []);

  if (!open) return null;

  const save = (next) => {
    writeConsent(next);
    loadAnalyticsIfAllowed();
    setOpen(false);
    setManage(false);
  };

  return (
    <div className="consent-banner" role="dialog" aria-labelledby="consent-title">
      <div className="consent-panel">
        <p id="consent-title" className="consent-title">{t('consent_title')}</p>
        <p className="consent-text">{t('consent_text')}</p>

        {manage && (
          <label className="consent-option">
            <input
              type="checkbox"
              checked={analytics}
              onChange={(e) => setAnalytics(e.target.checked)}
            />
            <span>{t('consent_analytics')}</span>
          </label>
        )}

        <div className="consent-actions">
          {!manage ? (
            <>
              <button type="button" className="btn-secondary" onClick={() => save({ necessary: true, analytics: false })}>
                {t('consent_necessary')}
              </button>
              <button type="button" className="btn-ghost" onClick={() => setManage(true)}>
                {t('consent_manage')}
              </button>
              <button type="button" className="btn-primary" onClick={() => save({ necessary: true, analytics: true })}>
                {t('consent_accept')}
              </button>
            </>
          ) : (
            <button type="button" className="btn-primary" onClick={() => save({ necessary: true, analytics })}>
              {t('consent_save')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
